 /* eslint-disable */
import { CommonGet,CommonPost } from '../helpers/HttpClient';

export default {
    getUserRole,
    getRoleLevels
};

async function getUserRole(group,factory) {
    const response = await CommonGet('/api/Role/GetRoleDetailsByGroupIDFactoryID', 'groupID=' + parseInt(group) + '&factoryID=' + parseInt(factory));
    if(response.data!=null){
        return response.data;
    }
   return null;
}


async function getRoleLevels() {
    const response = await CommonGet('/api/Role/GetAllRoleLevels',null);
    if(response.data!=null){
        return response.data;
    }
   return null;
}